export const sectionsData =

{
    outside: [
        {
            'image': require('./images/thehut/outside/outside_1.png')
        },
        {
            'image':
                require('./images/thehut/outside/hut_tube_1.jpg')
        },
        {
            'image':
                require('./images/thehut/outside/hut_tube_3.jpg')
        },
        {
            'image':
                require('./images/thehut/outside/electric_charging_points_1.jpg')
        },
        {
            'image':
                require('./images/thehut/outside/outside_4.png')
        },

    ],
    inside: [
        {
            'image': require('./images/thehut/inside/space_1.png')
        },
        {
            'image': require('./images/thehut/inside/bathroom_1.jpg')
        },
        {
            'image': require('./images/thehut/inside/kitchen_1.jpg')
        },
        {
            'image': require('./images/thehut/inside/space_2.jpg')
        },
        {
            'image': require('./images/thehut/inside/inside_2.jpg')
        },

    ],
    practicalities: [
        {
            'image': require('./images/thehut/practicalities/breakfast_1.png')
        },
        {
            'image': require('./images/thehut/practicalities/breakfast_2.png')
        },
        {
            'image': require('./images/thehut/practicalities/dinner_1.jpg')
        },
        {
            'image': require('./images/thehut/practicalities/breakfast_1.png')
        },
        {
            'image': require('./images/thehut/practicalities/breakfast_1.png')
        },

    ],
    vesterborg: [
        {
            'image': require('./images/area/vesterborg/vesterborg_1.png')
        },
        {
            'image': require('./images/area/vesterborg/vesterborg_2.jpg')
        },
        {
            'image': require('./images/area/vesterborg/vesterborg_3.jpg')
        },
        {
            'image': require('./images/area/vesterborg/vesterborg_4.jpg')
        },
        {
            'image': require('./images/area/vesterborg/vesterborg_5.jpg')
        },

    ],
    restaurants: [
        {
            'image': require('./images/area/restaurant/restaurant_1.png')
        },
        {
            'image': require('./images/area/restaurant/restaurant_2.jpg')
        },
        {
            'image': require('./images/area/restaurant/restaurant_3.jpeg')
        },
        {
            'image': require('./images/area/restaurant/restaurant_4.png')
        },
        {
            'image': require('./images/area/restaurant/restaurant_5.png')
        },
    ],
    experiences: [
        {
            'image': require('./images/area/nature/nature_1.png')
        },
        {
            'image': require('./images/area/nature/nature_2.png')
        },
        {
            'image': require('./images/area/nature/nature_3.png')
        },
        {
            'image': require('./images/area/nature/nature_4.png')
        },
        {
            'image': require('./images/area/nature/nature_5.png')
        },
    ],
    goforadrive: [
        {
            'image': require('./images/area/gofordrive/gofordrive_1.png')
        },
        {
            'image': require('./images/area/gofordrive/gofordrive_2.png')
        },
        {
            'image': require('./images/area/gofordrive/gofordrive_3.png')
        },
        {
            'image': require('./images/area/gofordrive/gofordrive_4.png')
        },
        {
            'image': require('./images/area/gofordrive/gofordrive_5.png')
        },
    ],
    smalltowncharm: [
        {
            'image': require('./images/area/smalltown/town_1.png')
        },
        {
            'image': require('./images/area/smalltown/town_2.jpg')
        },
        {
            'image': require('./images/area/smalltown/town_3.jpg')
        },
        {
            'image': require('./images/area/smalltown/town_3.png')
        },
        {
            'image': require('./images/area/smalltown/town_4.jpg')
        },
    ],
    aboutus: [
        {
            'image': require('./images/aboutus/black_image.png')
        },
        {
            'image': require('./images/aboutus/nature_panaroma.png')
        },
        {
            'image': require('./images/aboutus/art.png')
        },
        {
            'image': require('./images/aboutus/tube.png')
        },
    ]

}

